import { PlayCircle } from "lucide-react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function PlayButton({ onClick }: any) {
  return (
    <div className="cursor-pointer" onClick={onClick}>
      <PlayCircle className="h-auto w-[60px] text-white" strokeWidth={1} />
    </div>
  );
}
